export default __webpack_public_path__ + "static/media/nutrition-icon-brown.a6a8662c.svg";